module.exports = {
    Namespace: require('./lib/namespaces'),
    MUC: require('./lib/muc'),
    PubSub: require('./lib/pubsub'),
    Jingle: require('./lib/jingle'),
    Presence: require('./lib/presence')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/xmpp-constants/index.js
// module id = 0
// module chunks = 0